module.exports = __webpack_public_path__ + "static/AW_Pixxie-web_1920x1080-636f3b8855ee3e48878cedb5832eb381.jpg";